import type { Ref } from "vue";
import { onMounted } from "vue";

import { useNativeEvents } from "@/composables/useNativeEvents";
import type { ViewportCoordinate } from "@/model/coordinates";
import { initViewportCoord } from "@/model/coordinates";
import { clientCoord } from "@/utils/dom/coordinates";

const pointerPos: { down: ViewportCoordinate | null; current: ViewportCoordinate } = {
  down: null,
  current: initViewportCoord(),
};

export function usePointerPosition(elem: Ref<SVGSVGElement | null>) {
  const { addEventListener } = useNativeEvents();
  onMounted(() => {
    addEventListener(elem.value, "pointerdown", down);
    addEventListener(elem.value, "pointermove", move);
    addEventListener(elem.value, "pointerup", up);
    addEventListener(elem.value, "pointerout", up);
  });

  function down(e: PointerEvent) {
    pointerPos.down = clientCoord(e);
  }

  function move(e: PointerEvent) {
    pointerPos.current = clientCoord(e);
  }

  function up() {
    pointerPos.down = null;
  }

  return { pointerPos };
}
